import React, { useMemo } from 'react';
import Select from 'react-select';
import '../styles/SearchableSelect.css';

const selectStyles = {
  container: (base) => ({ ...base, minWidth: 0 }),
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderRadius: 6,
    backgroundColor: 'var(--theme-input-bg)',
    borderColor: state.isFocused ? 'var(--cor_exxer_roxo)' : 'var(--theme-border)',
    boxShadow: state.isFocused ? '0 0 0 3px var(--theme-focus)' : 'none',
    cursor: state.isDisabled ? 'not-allowed' : 'text',
    opacity: state.isDisabled ? 0.65 : 1,
    ':hover': {
      borderColor: state.isFocused ? 'var(--cor_exxer_roxo)' : 'var(--theme-border-strong)'
    }
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 12px' }),
  menu: (base) => ({
    ...base,
    zIndex: 20,
    backgroundColor: 'var(--theme-surface)',
    border: '1px solid var(--theme-border)',
    boxShadow: 'var(--theme-shadow)'
  }),
  menuList: (base) => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...base,
    borderRadius: 4,
    backgroundColor: state.isSelected
      ? 'var(--cor_exxer_roxo)'
      : state.isFocused
        ? 'var(--theme-accent-soft)'
        : 'transparent',
    color: state.isSelected ? '#fff' : 'var(--theme-text)',
    cursor: 'pointer',
    ':active': {
      backgroundColor: state.isSelected ? 'var(--cor_exxer_roxo)' : 'var(--theme-accent-soft)'
    }
  }),
  singleValue: (base) => ({ ...base, color: 'var(--theme-input-text)' }),
  input: (base) => ({ ...base, color: 'var(--theme-input-text)' }),
  placeholder: (base) => ({ ...base, color: 'var(--theme-text-subtle)' }),
  noOptionsMessage: (base) => ({ ...base, color: 'var(--theme-text-muted)' }),
  dropdownIndicator: (base) => ({ ...base, color: 'var(--theme-text-muted)' }),
  clearIndicator: (base) => ({ ...base, color: 'var(--theme-text-muted)' }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: 'var(--theme-border)' })
};

/**
 * Select pesquisável reutilizável. Expõe somente o valor da opção selecionada
 * para funcionar como um <select> controlado comum.
 */
const SearchableSelect = ({
  id,
  options = [],
  value,
  onChange,
  placeholder,
  noOptionsMessage,
  disabled = false,
  isClearable = true,
  className = '',
  ...props
}) => {
  const selectedOption = useMemo(
    () => options.find(option => String(option.value) === String(value)) || null,
    [options, value]
  );

  return (
    <Select
      inputId={id}
      className={`searchable-select ${className}`.trim()}
      classNamePrefix="searchable-select"
      options={options}
      value={selectedOption}
      onChange={option => onChange(option?.value ?? '')}
      placeholder={placeholder}
      noOptionsMessage={() => noOptionsMessage || placeholder}
      isDisabled={disabled}
      isClearable={isClearable}
      isSearchable
      styles={selectStyles}
      {...props}
    />
  );
};

export default SearchableSelect;
